import { categories } from '@/mocks/events';

interface FilterBarProps {
  activeCat: string;
  keyword: string;
  sort: 'hot' | 'latest';
  onCatChange: (catId: string) => void;
  onKeywordChange: (value: string) => void;
  onSortChange: (value: 'hot' | 'latest') => void;
  total: number;
}

export default function FilterBar({
  activeCat,
  keyword,
  sort,
  onCatChange,
  onKeywordChange,
  onSortChange,
  total,
}: FilterBarProps) {
  const chips = [{ id: 'all', name: '全部' }, ...categories];

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <form
          onSubmit={(event) => event.preventDefault()}
          role="search"
          className="flex w-full items-center gap-2 lg:max-w-md"
        >
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-background-100 text-foreground-500">
            <i className="ri-search-line text-lg leading-none" aria-hidden="true"></i>
          </span>
          <input
            type="search"
            value={keyword}
            onChange={(event) => onKeywordChange(event.target.value)}
            placeholder="搜索事件标题、标签或校园"
            aria-label="搜索校园事件"
            className="h-10 w-full rounded-md border border-background-200 bg-background-50 px-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
          />
        </form>

        <div className="flex items-center gap-2">
          <span className="text-xs text-foreground-500">排序</span>
          <div className="flex rounded-full border border-background-200 bg-background-100 p-1">
            <button
              type="button"
              onClick={() => onSortChange('hot')}
              className={`rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors ${
                sort === 'hot' ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-foreground-950'
              }`}
            >
              按热度
            </button>
            <button
              type="button"
              onClick={() => onSortChange('latest')}
              className={`rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors ${
                sort === 'latest'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-950'
              }`}
            >
              按时间
            </button>
          </div>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-background-200 pt-4">
        {chips.map((chip) => (
          <button
            key={chip.id}
            type="button"
            onClick={() => onCatChange(chip.id)}
            className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors ${
              activeCat === chip.id
                ? 'bg-foreground-950 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-background-200'
            }`}
          >
            {chip.name}
          </button>
        ))}
        <span className="ml-auto text-xs text-foreground-400">共 {total} 起事件</span>
      </div>
    </div>
  );
}